/* eslint-disable react/display-name */

import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/material/styles";
import Layout from "./src/components/Layout";
import { theme } from "./src/utils/theme";

/**
 * * Wraps every page in a component
 */
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  window.analytics &&
    window.analytics.page(location.href, {
      path: location.pathname,
      url: location.href,
      referrer: prevLocation ? prevLocation.href : null,
    });
};

export const wrapRootElement = ({ element }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>{element}</ThemeProvider>
    </QueryClientProvider>
  );
};
